module.exports = __webpack_public_path__ + "static/media/spinner.54a6df23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner.svg
// module id = 612
// module chunks = 1